export default {
  en: {
    marketList: 'Market List',
    agentList: 'Agent List',
    agentTypeList: 'Agent Type List',
    more: 'More',
    remove: 'Remove'
  },
  th: {
    marketList: 'ตลาด',
    agentList: 'ตัวแทน',
    agentTypeList: 'ประเภทตัวแทน',
    more: 'เพิ่มเติม',
    remove: 'ลบ'
  }
}
